import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import Logo from "./components/Logo/Logo";
import Dashboard from "./pages/Dashboard/Dashboard";
import NewPage from "./pages/NewPage/NewPage";
import EditPage from "./pages/EditPage/EditPage";
import Login from "./pages/Login/Login";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Logo />
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route exact path="/dashboard" element={<Dashboard />} />
        <Route exact path="/nova-pagina" element={<NewPage />} />
        <Route exact path="/editar-pagina/:id" element={<EditPage />} />
      </Routes>
    </>
  );
}

export default App;
